<template>
    <label class="form-label">
        <span class="required-label" :class="{required}">{{ required ? '必須' : '任意' }}</span>
        <slot></slot>
    </label>
</template>

<script>
export default {
    name: "FormLabel",
    props: {
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
label {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: fit-content;
}

span.required-label {
    background-color: #8894aa;
    border-radius: 4px;
    display: inline-block;
    width: 36px;
    height: 20px;
    margin-right: 16px;
    text-align: center;
    color: white;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.12em;
}

span.required-label.required {
    background-color: #e34343;
}
</style>
